// NOTE: 구매 이벤트 스크립트
const collect = () => {
  try {
    if (!window.karrotPixel || !window.karrotPixel.trackerId) return
    window.karrotPixel.track('Purchase')
  } catch (error) {
    const daagnScriptError = error as Error
    window.Rollbar?.warning(daagnScriptError.message, daagnScriptError)
  }
}

export default collect
